import { defineCustomElement } from '~/lit/define-custom-element';
import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../props/bin-current-report-date';
import './bin-level-metric';

class BinSummary extends LitEntity {
  constructor() {
    super();
    this.precision = 2;
  }

  static get properties() {
    return {
      inline: { type: Boolean },
      row: { type: Boolean },
      precision: { type: Number },
      latestReadingDate: { type: String, attribute: false },
      readingStatus: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline-block;
      }
      bin-current-report-date {
        font-size: .8em;
        color: var(--bin-current-report-date-color, #999);
        display: block;
      }
      bin-current-report-date.warning {
        --bin-current-report-date-color: var(--red-20);
      }
      :host([inline]) bin-current-report-date {
        display: inline-block;
      }
      :host([row]) bin-current-report-date {
        display: inline-block;
        float: right;
      }
    `];
  }

  render() {
    const hasWarningStatus = this.readingStatus === 'stale' || this.readingStatus === 'old';
    return html`
      <bin-level-metric
        .href="${this.href}"
        precision="${this.precision}"
        @levelUpdate="${this._onLevelUpdate}"
      ></bin-level-metric>
      <bin-current-report-date
        class="${hasWarningStatus ? 'warning' : ''}"
        .date="${this.latestReadingDate}"
      ></bin-current-report-date>
    `;
  }

  _onLevelUpdate({ detail }) {
    this.latestReadingDate = detail?.levelEntity?.properties?.publishedAt || null;
    this.readingStatus = detail?.status || null;
  }
}

defineCustomElement('bin-summary', BinSummary);
